import strings from 'common/Translation/Translate';

const PIN_REGEX = /^\d{4,9}$/;

const isBlank = (value: unknown): boolean => value == null || String(value).trim() === '';

export type ClearTaxValidationResult = {
  valid: boolean;
  errors: string[];
};

export type ClearTaxValidationOptions = {
  requireBuyerGstin?: boolean;
};

export const validateClearTaxPosting = (
  booking: Record<string, unknown> | null | undefined,
  pageResponse: Record<string, unknown> | null | undefined,
  options: ClearTaxValidationOptions = {},
): ClearTaxValidationResult => {
  const errors: string[] = [];
  const bookingData = booking ?? {};
  const requireBuyerGstin = options.requireBuyerGstin !== false;

  if (!pageResponse?.id) {
    errors.push(strings.clearTaxValidationActualizationRequired);
  }

  const totalCost = Number(pageResponse?.totalCost ?? 0);
  if (!Number.isFinite(totalCost) || totalCost <= 0) {
    errors.push(strings.clearTaxValidationTotalCostRequired);
  }

  if (requireBuyerGstin && isBlank(bookingData.gst)) {
    errors.push(strings.clearTaxValidationGstRequired);
  }

  const legalName = !isBlank(bookingData.companyName)
    ? String(bookingData.companyName).trim()
    : String(bookingData.customerName ?? '').trim();
  if (isBlank(legalName)) {
    errors.push(strings.clearTaxValidationLegalNameRequired);
  }

  if (isBlank(bookingData.address)) {
    errors.push(strings.clearTaxValidationAddressRequired);
  }

  if (isBlank(bookingData.city) && isBlank(bookingData.state)) {
    errors.push(strings.clearTaxValidationLocationRequired);
  }

  const pinCode = String(bookingData.pinCode ?? '').trim();
  if (isBlank(pinCode)) {
    errors.push(strings.clearTaxValidationPinCodeRequired);
  } else if (!PIN_REGEX.test(pinCode)) {
    errors.push(strings.clearTaxValidationPinCodeInvalid);
  }

  return { valid: errors.length === 0, errors };
};

export const formatClearTaxValidationMessage = (errors: string[]): string =>
  `${strings.clearTaxValidationTitle}: ${errors.join('; ')}`;
